/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { CreateOrganizationMutationRequest, CreateOrganizationMutationResponse, CreateOrganization400, CreateOrganization401, CreateOrganization403, CreateOrganization404, CreateOrganization409, CreateOrganization500 } from "../../types/organizationController/CreateOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getCreateOrganizationUrl() {
  const res = { method: 'POST', url: `/api/organizations/` as const }
  return res
}

/**
 * @summary Create organization
 * {@link /api/organizations/}
 */
export async function createOrganization(data: CreateOrganizationMutationRequest, config: Partial<RequestConfig<CreateOrganizationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateOrganizationMutationResponse, ResponseErrorConfig<CreateOrganization400 | CreateOrganization401 | CreateOrganization403 | CreateOrganization404 | CreateOrganization409 | CreateOrganization500>, CreateOrganizationMutationRequest>({ method : "POST", url : getCreateOrganizationUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}